export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Audio Extractor",
  "Extract sound from videos with ease.": "Extraheer met gemak geluid uit video's.",
  "Select Audio Format": "Kies Audioformaat",
  "Extract Audio": "Audio extraheren",
  "Extracting Audio": "Audio uitpakken",
  "Extracted Successfully": "Succesvol uitgepakt",
  "Extract New": "Nieuw uitpakken",
  "Extraction Failed": "Uitpakken mislukt",
  "Format": "Formaat",
};
